import { useCallback } from "react";
import type { CcofCaptureLinkInitiateResponse } from "lib/api-types/schemas";
import { useUpdatePatientCardCache } from "./useUpdatePatientCardCache";

export function useUpdateCaptureCache(patientId: string) {
  const updatePatientCardCache = useUpdatePatientCardCache(patientId);

  return useCallback(
    (response: CcofCaptureLinkInitiateResponse) => {
      if (response.smsSent) {
        const cardCapture = {
          sessionId: response.captureSessionId!,
          state: "sent",
        } as const;
        updatePatientCardCache({ cardCapture });
      }
    },
    [updatePatientCardCache],
  );
}
